import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/eed95196-edbd-43f3-9b86-9be78fd97250.jpg';
const PARTICLES = [{
  top: '18%',
  left: '12%',
  delay: '0s',
  size: 'w-1.5 h-1.5'
}, {
  top: '32%',
  left: '82%',
  delay: '0.8s',
  size: 'w-1 h-1'
}, {
  top: '65%',
  left: '18%',
  delay: '1.4s',
  size: 'w-2 h-2'
}, {
  top: '75%',
  left: '70%',
  delay: '0.4s',
  size: 'w-1 h-1'
}, {
  top: '22%',
  left: '55%',
  delay: '2s',
  size: 'w-1.5 h-1.5'
}, {
  top: '48%',
  left: '90%',
  delay: '1s',
  size: 'w-1 h-1'
}, {
  top: '85%',
  left: '40%',
  delay: '2.6s',
  size: 'w-1.5 h-1.5'
}, {
  top: '10%',
  left: '35%',
  delay: '1.8s',
  size: 'w-1 h-1'
}, {
  top: '55%',
  left: '6%',
  delay: '0.6s',
  size: 'w-1 h-1'
}, {
  top: '38%',
  left: '25%',
  delay: '2.2s',
  size: 'w-2 h-2'
}];
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" className="relative min-h-screen w-full flex flex-col justify-end pb-10 sm:pb-16 overflow-hidden" data-id="element-106" data-mp="3825xqp13i5ku">
      {/* Background image */}
      <img src={HERO_IMAGE} alt="Especialista en crecimiento digital con interfaz holográfica" className="absolute inset-0 w-full h-full object-cover z-0" data-id="element-107" data-mp="3o7lq5lizewmb" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30 z-10" data-id="element-108" data-mp="39cpbapgo3b09" />

      {/* Floating particles */}
      <div className="absolute inset-0 pointer-events-none hidden md:block z-10" data-id="element-109" data-mp="30hhsrvwdzt3r">
        {PARTICLES.map((p, i) => <span key={i} className={`absolute rounded-full bg-white/60 animate-float ${p.size}`} style={{
        top: p.top,
        left: p.left,
        animationDelay: p.delay
      }} data-id="element-110" data-mp="359j9pv4i2804" data-mpi={i} />)}
      </div>

      {/* Top row: badge + MMXXV, absolutely positioned so it never collides with the headline */}
      <div className="absolute top-4 left-4 right-4 sm:top-6 sm:left-6 sm:right-6 z-20 flex justify-between items-center gap-2" data-id="element-111" data-mp="2hjymh01bcol1">
        <span className="inline-flex items-center gap-1.5 sm:gap-2 border border-white/20 rounded-full px-3 py-1 sm:px-4 sm:py-1.5 text-[10px] sm:text-xs uppercase tracking-widest text-white/80 min-w-0 max-w-[78%] sm:max-w-none" data-id="element-112" data-mp="s21k8hdb6o2m">
          <span className="relative flex w-1.5 h-1.5 sm:w-2 sm:h-2 shrink-0" data-id="element-113" data-mp="id9u8ert6duc">
            <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-pulse-ring" data-id="element-114" data-mp="ddnhs7jt11ml" />
            <span className="relative inline-flex rounded-full w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-400" data-id="element-115" data-mp="1azumdhg3ytyy" />
          </span>
          <span className="truncate" data-id="element-116" data-mp="162c95ev25sl5">{t.hero_badge}</span>
        </span>
        <span className="text-[10px] sm:text-xs text-white/30 tracking-widest shrink-0" data-id="element-117" data-mp="111okgzuaxnu3">
          MMXXV
        </span>
      </div>

      {/* Main content, anchored to the bottom of the hero */}
      <div className="relative z-20 px-5 sm:px-8 max-w-4xl" data-id="element-118" data-mp="3lt74enpyzlso">
        <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-6xl lg:text-7xl leading-[1.1] sm:leading-[1.05]" data-id="element-119" data-mp="3lqm4w5d59hy3">
          <span className="block text-white" data-id="element-120" data-mp="1x9ukuaytndnf">{t.hero_h1_line1}</span>
          <span className="block text-white" data-id="element-121" data-mp="1x7hvhcqqi10c">{t.hero_h1_line2}</span>
          <span className="block" data-id="element-122" data-mp="21bfs9gsl6zq8">
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent" data-id="element-123" data-mp="269zk1xtv35qi">
              {t.hero_h1_line3_gradient}
            </span>
            <span className="text-white" data-id="element-124" data-mp="2b20qv489g495"> {t.hero_h1_rest}</span>
          </span>
          <span className="block text-white" data-id="element-125" data-mp="2fz0vrbtdj0yo">{t.hero_h1_line4}</span>
        </h1>

        <p className="text-sm sm:text-base text-white/65 leading-relaxed max-w-lg mt-4 sm:mt-6" data-id="element-126" data-mp="2ky42r1swzh9a">
          {t.hero_sub}
        </p>

        <div className="mt-6 sm:mt-8 flex flex-wrap gap-3 sm:gap-4" data-id="element-127" data-mp="2p1a6o2sk0wcl">
          <a href="#portafolio" className="bg-yellow-400 text-black font-bold px-5 sm:px-6 py-2.5 sm:py-3 rounded text-xs sm:text-sm hover:brightness-110 transition-all duration-200" data-id="element-128" data-mp="2tyiqe7tcp8fy">
            {t.hero_cta1}
          </a>
          <a href="https://wa.me/34634234462" target="_blank" rel="noopener noreferrer" className="border border-white/30 text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded text-xs sm:text-sm hover:bg-white/10 transition-all duration-200" data-id="element-129" data-mp="4bdxli20sdpo">
            {t.hero_cta2}
          </a>
        </div>
      </div>
    </section>;
}